import React from 'react';
import { connect } from 'react-redux';
import { DBIntFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthGripStrength extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Grip Strength' />
                <label className={styles.textarea_label}>Grip Strength</label>
                <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESTR'
                    entityKeyColumn='STNO'
                    entityKeyValue={this.props.stno}
                    field='STGRIPSTRENGTHR'
                    className={styles.r}
                />
                <span className={styles.c} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevStrR}
                    </span>
                </span>
                <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESTR'
                    entityKeyColumn='STNO'
                    entityKeyValue={this.props.stno}
                    field='STGRIPSTRENGTHL'
                    className={styles.l}
                />
                <span className={styles.prev_wrapper}>
                    {this.props.prevStrL}
                </span>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevStrR = '';
    let prevStrL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STGRIPSTRENGTHR'];
        prevStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STGRIPSTRENGTHL'];
    }

    return {
        noteId: noteId,
        stno: stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno].STGRIPSTRENGTHR ||
            state.entities.notes.PTOBJECTIVESTR[stno].STGRIPSTRENGTHL
            ? true : false,
        prevStrR,
        prevStrL,
    };
}

const connectedStrengthGripStrength = connect(mapStateToProps)(StrengthGripStrength);
export { connectedStrengthGripStrength as StrengthGripStrength };


